import { useState } from 'react';
import Image from 'next/image';
import { Typography } from '@mui/material';
import NoData from '@/images/animations/no_review_post.gif';
import { REVIEW_ROUTES } from '@/constants/path.constants';
import DashboardSectionContainer from '@/views/appstore/dashboard/components/DashboardSectionContainer';
import SetAppStoreButton from '@/views/appstore/dashboard/components/SetAppStoreButton';

const NoPostDataEndCrawling = ({ isMobile }: { isMobile: boolean }) => {
  const [showSearchModal, setShowSearchModal] = useState(false);
  return (
    <DashboardSectionContainer isMobile={isMobile}>
      <>
        <Image src={NoData.src} alt="리뷰 없음" width={200} height={200} />
        <Typography variant="subtitle2" marginBottom="32px" textAlign="center">
          현재 채널에 등록된 리뷰가 없습니다.
          <br />
          앞으로 채널에 리뷰가 작성되면 자동으로 수집됩니다.
          <br />
          <br />
          혹시 병원을 잘못 설정하셨다면, 다시 설정해 주세요.
        </Typography>
        <SetAppStoreButton showSearchModal={showSearchModal} setShowSearchModal={setShowSearchModal} />
      </>
    </DashboardSectionContainer>
  );
};

export default NoPostDataEndCrawling;
